module.exports = __webpack_public_path__ + "media/images/active-d929bdd542bfd3f3ad2dacaa2293445a.svg";